<template>
<v-container class="no-p" fluid>
  <v-app-bar app>
        <v-btn icon to="/courier"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-toolbar-title>{{title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon to="/help">
          <v-icon>flaticon-information</v-icon>
        </v-btn>
        <v-btn v-if="showDelivery == true" icon to="/delivery-form">
          <v-icon>flaticon-food</v-icon>
        </v-btn>
      </v-app-bar>
      <div class="custom-preogress-container">
                <v-progress-linear height="6" v-model="currentStatus.trackingestatus"></v-progress-linear>
                 <!--<div class="custom-preogress">
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step1.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step2.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step3.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step4.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step5.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step6.png" alt />
                  </div>
                </div> -->
              </div>

              <div class="new-list-of-packages" v-if="items.length > 0">
      <v-list three-line>
        <template v-for="(item, index) in items">
          <v-list-item :key="index" >

            <v-list-item-content>


              <div class="new-list-of-packages__item-content">
                <div class="new-list-of-packages__genearl-info">


                  <v-list-item-title class="new-list-of-packages__title" v-html="item.contenido"></v-list-item-title>
                  <div class="detail__text">
                    Recibido el {{item.fec_creacion}}
                  </div>
                  <div class="detail__text">
                    Tracking No. {{item.tracking_number}}
                  </div>
                  <div class="detail__text">
                    Guia No.{{item.guia}}
                  </div>
                  <div v-if="item.mostrar_boton !== 0" class="mt-3"></div>
              <v-btn

                v-if="item.mostrar_boton == 0"
                :loading="loading"
                :disabled="loading"
                large
                class="white blue-grey--text darken-3 mt-2"

                @click="pickFile(item.guia,item.id_)"
              >

              <v-img src="@/assets/upload_file.svg" height="30"></v-img>
                Subir Factura
                <!-- <v-icon right dark>cloud_upload</v-icon> -->
              </v-btn>
                </div>
                <div class="new-list-of-packages__important-info">
                  <div>
                    Pesa <br> {{ item.peso + " " + ((item.peso > 1) ? " Libras" : " Libra") }}
                  </div>
                  <div>
                    Pesa <br> {{ item.peso + " " + ((item.peso > 1) ? " Libras" : " Libra") }}
                  </div>
                </div>

              </div>

            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </div>

      <div v-else>
        <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          {{language.you_have_no_data_available}}
        </div>
      </div>
        <v-progress-circular :size="90" color="blue" indeterminate class="loading-center" v-else></v-progress-circular>
      </div>
      <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />
<v-container>

</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
// import { mapState } from "vuex";
var files = [];
export default {
  created() {
    console.log(this.storeStatus)
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      newValue => {
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
          }
        }
      }
    );
    this.$store.watch(
      (state, getters) => getters.profile,
      // (newValue, oldValue) => {
      () => {
        this.showDeliveryFc();
      }
    );
  },
  mounted() {
    console.log(this.$route.params);

    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }

    this.showDeliveryFc();
  },
  props: ['status'],
  data() {
    return {
      clipped: false,
      items: [],
      currentUser: undefined,
      noData: false,
      loading: false,
      imageFile: null,
      imageName: "",
      guia: null,
      idpack: null,
      showDelivery: false,
      // title:"test"
      // title: this.$route.params.status.total_paquetes + ' ' + ((parseInt(this.$route.params.status.total_paquetes) > 1) ? ' artículos ' : ' artículo ') +  this.$route.params.status.desc_estatus_proceso
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    login() {
      return this.$store.getters.login;
    },
    profile: function() {
      return this.$store.getters.profile;
    },
    storeStatus: function() {
      return this.$store.getters.status;
    },
    currentStatus: function(){
      var status = [];
      for (let index = 0; index < this.storeStatus.length; index++) {
        if(this.$route.params.status === this.storeStatus[index].id_estatus_proceso){
          return this.storeStatus[index];
        }
      }
      return status;
    },
    title: function () {
      if(this.currentStatus === []){
        return "Artículos"
      }
      return this.currentStatus.total_paquetes + ' ' + ((parseInt(this.currentStatus.total_paquetes) > 1) ? ' artículos ' : ' artículo ') +  this.currentStatus.desc_estatus_proceso
    },
  },
  methods: {
    showDeliveryFc() {
      if (this.profile.length > 0) {
        if (
          this.profile[0].domicilio != "" &&
          this.profile[0].domicilio != 0 &&
          this.profile[0].domicilio != "0" &&
          this.profile[0].domicilio != undefined
        ) {
          this.showDelivery = true;
        } else {
          this.showDelivery = false;
        }
      } else {
        this.showDelivery = false;
      }
    },
    pickFile(guia, idpack) {
      window.MobileApi.uploadInvoice(
        Server.uploadInvoice,
        guia,
        idpack,
        this.currentUser.userName,
        this.getPacks
      );
    },
    onFilePicked() {
      this.loading = true;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageFile = files[0]; // this is an image file that can be sent to server...
          var formData = new FormData();
          formData.append("text1", this.currentUser.userName);
          formData.append("text3", this.currentUser.pushId);
          formData.append("device", window.MobileApi.device);
          formData.append("PARAMETRO2", this.guia);
          formData.append("PARAMETRO1", this.idpack);
          formData.append("photo", this.imageFile);
          this.$http.post(Server.uploadInvoice, formData).then(
            // response => {
            () => {
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        });
      }
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("text4", this.currentStatus.id_estatus_proceso);
      formData.append("device", window.MobileApi.device);
      console.log(this.currentUser);
      this.$http.post(Server.packs, formData).then(
        response => {
          if (response.body.resultado !== "NO") {
            this.items = response.body;
            console.log(this.items );
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
